import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import classNames from 'classnames'
import { OmDropdownMenu, type OmDropdownMenuConfig, type OmMenuClickInfo } from '@owma/kit'
import { languageMap } from 'i18n'

import LanguageIcon from 'assets/images/chevron-down-24.svg'

import styles from './style.module.scss'

const { ko, en, ja } = languageMap

const langMap: Record<string, any> = {
  ko,
  en,
  ja,
}

interface LanguageSwitcherProps {
  onChange?: (locale: string) => void
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = (props) => {
  const dispatch = useDispatch()
  // const locale = useSelector((state) => state.settings.locale, (objA, objB) => {
  //   return objA === objB;
  // });
  // locale 은 local-only — localSettings.general.locale 에서 읽는다(서버 sync 대상 아님).
  const locale = useSelector((state: any) => state.settings.localSettings?.general?.locale)

  const changeLanguage = (info: OmMenuClickInfo) => {
    const { key } = info

    dispatch({
      type: 'settings/SET_LOCALE',
      payload: {
        locale: key,
      },
    })

    if (props.onChange != null) {
      setTimeout(() => {
        props.onChange!(key)
      }, 70)
    }

    info.domEvent?.stopPropagation()
  }

  const onClick = (e: React.MouseEvent) => {
    e.stopPropagation()
  }

  const langCode = locale.substr(0, 2)

  const language = langMap[langCode.toLowerCase()].name

  const menu: OmDropdownMenuConfig = {
    selectedKeys: [locale],
    selectable: true,
    onClick: changeLanguage,
    items: [
      // {
      //   key: 'ko-KR',
      //   label: (
      //     <React.Fragment>
      //       <span className="text-uppercase font-size-12 mr-2">KO</span>
      //       한국어
      //     </React.Fragment>
      //   ),
      // },
      // {
      //   key: 'en-US',
      //   label: (
      //     <React.Fragment>
      //       <span className="text-uppercase font-size-12 mr-2">EN</span>
      //       English
      //     </React.Fragment>
      //   ),
      // },
      // Disable the laguages below - FR, RU, CN
      // {
      //   key: 'fr-FR',
      //   label: (
      //     <React.Fragment>
      //       <span className="text-uppercase font-size-12 mr-2">FR</span>
      //       French
      //     </React.Fragment>
      //   )
      // },
      // {
      //   key: 'ru-RU',
      //   label: (
      //     <React.Fragment>
      //       <span className="text-uppercase font-size-12 mr-2">RU</span>
      //       Русский
      //     </React.Fragment>
      //   )
      // },
      // {
      //   key: 'zh-CN',
      //   label: (
      //     <React.Fragment>
      //       <span className="text-uppercase font-size-12 mr-2">CN</span>
      //       简体中文
      //     </React.Fragment>
      //   )
      // },
    ],
  }

  menu.items = Object.entries(langMap).map(([key, value]) => {
    return {
      key: value.code,
      label: (
        <React.Fragment>
          <span className="text-uppercase font-size-12 mr-2">{key.toUpperCase()}</span>
          {value.name}
        </React.Fragment>
      ),
    }
  })

  return (
    <OmDropdownMenu
      className={styles.languageSwitcher}
      overlayClassName={classNames('contextMenu')}
      menu={menu}
      trigger={['click']}
      placement="bottomRight"
    >
      <div className={styles.dropdown} onClick={onClick}>
        <span className="text">{language}</span>
        <img src={LanguageIcon} alt="language" />
      </div>
    </OmDropdownMenu>
  )
}

export default LanguageSwitcher
